import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../configs/api";
import VerifyToken from "../../../api/VerifyToken";
import Cookies from "js-cookie";

import { Context } from "../../../Context/AuthContext";

const SignIn = () => {
  const { values } = useContext(Context);

  const [passwordMode, setPasswordMode] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    const token = Cookies.get("token");

    if (token) {
      VerifyToken("admin/get_admin").then((resultUsers) => {
        if (resultUsers) {
          values.logIn.setIsLog(true);
          navigate(path);
        }
      });
    }
  }, []);

  const navigate = useNavigate();

  const [user, setUser] = useState({});
  const [path, setPath] = useState("/admin/home");

  function handlePasswordMode() {
    setPasswordMode(!passwordMode);
  }

  const [checkInput, setCheckInput] = useState({
    email: false,
    password: false,
    type: false,
  });

  const [messageWarning, setMessageWarning] = useState({
    email: "",
    password: "",
    submit: "",
  });

  function handleEmail(event) {
    const patternEmail = /^[A-z0-9\.]+@[A-z0-9]+\.[A-z]{3,5}$/;
    const email = event.target.value;
    setCheckInput({ ...checkInput, email: false });

    if (email === "") {
      setMessageWarning({ ...messageWarning, email: "This field is required" });
    } else if (!patternEmail.test(email)) {
      setMessageWarning({ ...messageWarning, email: "Invalid email" });
    } else {
      setMessageWarning({ ...messageWarning, email: "" });
      setUser({ ...user, email: email });
      setCheckInput({ ...checkInput, email: true });
    }
  }

  function handlePassword(event) {
    const patternPassword =
      /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,.?]).{8,}$/;
    const password = event.target.value;
    setCheckInput({ ...checkInput, password: false });
    if (password === "") {
      setMessageWarning({
        ...messageWarning,
        password: "This field is required",
      });
    } else if (!patternPassword.test(password)) {
      setMessageWarning({
        ...messageWarning,
        password: `Invalid password, Password must consist of 8 characters, with at least 1 number, uppercase, and special characters`,
      });
    } else {
      setMessageWarning({ ...messageWarning, password: "" });
      setUser({ ...user, password: password });
      setCheckInput({ ...checkInput, password: true });
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const email = event.target.email.value;
    const password = event.target.password.value;

    if (!checkInput.email && !checkInput.password) {
      setMessageWarning({
        ...messageWarning,
        submit: "You must fill in the fields.",
      });
      return;
    }

    try {
      const res = await api.post(`/authentication/admin_login`, {
        email: email,
        password: password,
      });

      Cookies.set("token", res.data.token);
      values.logIn.setIsLog(true);
      navigate(path);
    } catch (err) {
      setMessageWarning({
        ...messageWarning,
        submit: "The email or password is not valid",
      });
      console.error(err);
    }
  }

  return (
    <>
      <div className=' bg-[#bbb9b4] dark:bg-gray-900 h-screen flex  items-center justify-center'>
        {" "}
        <div className='flex items-center justify-center w-[50%]'>
          <div className='w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 border-primary xl:border-2'>
            <div className='w-full p-4 sm:p-12.5'>
              <h2 className='mb-9 text-3xl  font-bold text-primary dark:text-white sm:text-title-xl2'>
                Sign In to Admin Shadow
              </h2>
              <form onSubmit={handleSubmit}>
                <div className='mb-4'>
                  <div className='w-full mb-4'>
                    <label
                      className='text-bold-color text-sm font-semibold '
                      htmlFor='email'
                    >
                      Email
                    </label>
                    <input
                      onBlur={handleEmail}
                      className='border-2 border-primary rounded-md px-3 py-2 w-full focus:border-primary focus:ring-1 focus:ring-primary'
                      id='email'
                      type='text'
                      name='email'
                    />
                    <span
                      className='text-red-500 text-xs'
                      style={{ fontSize: "13px" }}
                    >
                      {messageWarning.email}
                    </span>
                  </div>
                </div>

                <div className='mb-6'>
                  <div className='relative'>
                    <label
                      className='text-bold-color text-sm font-semibold '
                      htmlFor='password'
                    >
                      Password
                    </label>
                    <input
                      onBlur={handlePassword}
                      className='border-2 border-primary rounded-md px-3 py-2 w-full  focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary'
                      id='password'
                      type={passwordMode ? "password" : "text"}
                    />
                    <span
                      className='absolute right-[13px] top-[33px] flex items-center'
                      onClick={handlePasswordMode}
                    >
                      <svg
                        width='25'
                        height='25'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        {passwordMode ? (
                          <>
                            <path
                              d='M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z'
                              stroke='#000000'
                              strokeWidth='2'
                              stroke-linecap='round'
                              stroke-linejoin='round'
                            />
                            <path
                              d='M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z'
                              stroke='#000000'
                              stroke-width='2'
                              stroke-linecap='round'
                              stroke-linejoin='round'
                            />
                          </>
                        ) : (
                          <path
                            d='M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5'
                            stroke='#000000'
                            stroke-width='2'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                          />
                        )}
                      </svg>

                      <i
                        className={`fas fa-eye ${
                          passwordMode ? "block" : "hidden"
                        }`}
                      />
                      <i
                        className={`fas fa-eye-slash ${
                          passwordMode ? "hidden" : "block"
                        }`}
                      />
                    </span>
                    <span
                      className='text-red-500 text-xs'
                      style={{ fontSize: "13px" }}
                    >
                      {messageWarning.password}
                    </span>
                  </div>
                </div>

                <div className='mb-5'>
                  <input
                    type='submit'
                    value='Sign In'
                    className='w-full cursor-pointer rounded-lg border border-primary bg-primary p-4 text-white transition hover:bg-opacity-90'
                  />
                </div>
                <span
                  className='error-Massage text-center'
                  style={{ color: "red", fontSize: "13px" }}
                >
                  {messageWarning.submit}
                </span>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignIn;
